'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');

var mediaQueryDefault = {
    desktop: false,
    mobile: false,
    table: false,
};
var useMediaQueries = function () {
    var _a = React.useState(mediaQueryDefault), mediaMatch = _a[0], setMediaMatch = _a[1];
    var onChangeMedia = function (mediaKey, media) {
        if (!media.matches) {
            return;
        }
        setMediaMatch(function (prev) {
            var _a;
            return tslib_es6.__assign(tslib_es6.__assign({}, mediaQueryDefault), (_a = {}, _a[mediaKey] = true, _a));
        });
    };
    React.useEffect(function () {
        if (typeof window === 'undefined') {
            return;
        }
        var mobileQueryList = window.matchMedia("(max-width: 480px)");
        var tabletQueryList = window.matchMedia("(min-width: 481px) and (max-width: 768px)");
        var desktopQueryList = window.matchMedia("(min-width: 769px)");
        var mediaChangeHandler = function () {
            onChangeMedia('mobile', mobileQueryList);
            onChangeMedia('table', tabletQueryList);
            onChangeMedia('desktop', desktopQueryList);
        };
        mediaChangeHandler();
        mobileQueryList.addEventListener('change', mediaChangeHandler);
        tabletQueryList.addEventListener('change', mediaChangeHandler);
        desktopQueryList.addEventListener('change', mediaChangeHandler);
        return function () {
            mobileQueryList.removeEventListener('change', mediaChangeHandler);
            tabletQueryList.removeEventListener('change', mediaChangeHandler);
            desktopQueryList.removeEventListener('change', mediaChangeHandler);
        };
    }, []);
    return mediaMatch;
};

exports.default = useMediaQueries;
exports.useMediaQueries = useMediaQueries;
//# sourceMappingURL=useMediaQueries.js.map
